import { render, staticRenderFns } from "./WeChatAuth.vue?vue&type=template&id=09ce5c0c&scoped=true"
import script from "./WeChatAuth.vue?vue&type=script&lang=js"
export * from "./WeChatAuth.vue?vue&type=script&lang=js"
import style0 from "./WeChatAuth.vue?vue&type=style&index=0&id=09ce5c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce5c0c",
  null
  
)

export default component.exports